import { render, staticRenderFns } from "./ProRiskQuotationCard.vue?vue&type=template&id=448d4deb&scoped=true&"
import script from "./ProRiskQuotationCard.vue?vue&type=script&lang=ts&"
export * from "./ProRiskQuotationCard.vue?vue&type=script&lang=ts&"
import style0 from "./ProRiskQuotationCard.vue?vue&type=style&index=0&id=448d4deb&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448d4deb",
  null
  
)

export default component.exports